import {Address, MoneycardOtlRuleManagement, User} from '~/shared/store/models';
import {B2bJoinModes} from '~/shared/types/B2bjoin';

export interface IMarketingBannerParams {
  longitude?: string | number;
  latitude?: string | number;
  cityId?: Address['cityId'];
}

export interface IUpdateUserParams {
  userDetails: Partial<User>;
  authenticationCode: string | number;
  authenticationToken: string | number;
}

export interface IUserConfig {
  headers: {
    'session-token': string;
  };
}

export interface IOrderParams {
  orderId: number;
}

export interface ILoadTenbisCredit {
  amount: number | string;
  moneycardIdToCharge: number;
}

export interface IAutoCreditSubscription {
  encryptedMoneycardId: string;
  autoCreditSubscribed: boolean;
}

export enum BrandingPageTypes {
  UNKNOWN = 'unknown',
  OTP = 'otp',
  REGISTRATION = B2bJoinModes.REGISTRATION,
  ADD_NEW_CC = B2bJoinModes.ADD_NEW_CC,
  OTL = B2bJoinModes.OTL
}

export type IFetchBrandingPageDataParams = {
  token?: string;
  pageType: BrandingPageTypes;
};

export interface IRestaurantGroupsParams {
  type: 'group' | 'chain';
}

export interface IGetRestaurantMenuParams {
  id: number;
  dateTime?: string;
  addressId?: number;
}

export interface IGetRestaurantParams {
  id: number;
  addressId?: number;
  longitude?: number;
  latitude?: number;
}

export enum CommunicationMethodName {
  EMAIL = 'Email',
  PUSH = 'Push',
  SMS = 'Sms',
}

export const isCommunicationMethodName = (value: string): value is CommunicationMethodName => {
  return Object.values(CommunicationMethodName).includes(value as CommunicationMethodName);
};

export type UpdateUserNotificationsPreferencesParams = {
  enabled: boolean;
  communicationMethod: CommunicationMethodName;
};

export type UpsertOverTheLimitRuleParams = Omit<MoneycardOtlRuleManagement['otlRule'], 'ruleId' | 'limitations'> & {
  encryptedMoneycardId: string;
  creditcardId?: number;
  ruleActive?: boolean;
  singleTransactionLimit?: number;
  singleTransactionLimitEnabled?: boolean;
  dailyLimit?: number;
  dailyLimitEnabled?: boolean;
  monthlyLimit?: number;
  monthlyLimitEnabled?: boolean;
};
